import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateGoal } from "../database-goals";
import { goalQueryKeys } from "../operations/goal-query-keys";
import { useUser } from "@/hooks/auth/use-user";
import { supabase } from "@/integrations/supabase/client";

export function useUpdateGoalMutation() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  return useMutation({
    mutationFn: async ({ goalId, updates }: { goalId: string, updates: any }) => {
      if (!user) throw new Error("Not signed in");
      return updateGoal(goalId, updates, user.id);
    },
    onSuccess: async (updatedGoal, { goalId }) => {
      if (!user) return;
      
      // Invalidate standard goal queries
      queryClient.invalidateQueries({ queryKey: goalQueryKeys.byId(user.id, goalId) });
      queryClient.invalidateQueries({ queryKey: goalQueryKeys.user(user.id) });
      
      // Find associated workbook to invalidate workbook-goal query
      try {
        const { data } = await supabase
          .from('planner_goals_workbooks')
          .select('workbook_id')
          .eq('goal_id', goalId)
          .single();
          
        if (data?.workbook_id) {
          // Invalidate the workbook-goal query
          queryClient.invalidateQueries({ queryKey: ['workbook-goal', data.workbook_id] });
        }
      } catch (error) {
        console.warn('Could not determine workbook for goal cache invalidation', error);
      }
    }
  });
}
